const FormCheck = ({ value, onChange, name, children }) => {
  return (
    <label htmlFor={name}>
      <input type="checkbox" name={name} onChange={onChange} checked={value} />
      {children}
    </label>
  );
};

export default FormCheck;
